document.addEventListener('DOMContentLoaded', () => {
  const text = document.getElementById('about-ong-text');
  const buttons = document.querySelectorAll('.about-ong__tab');

  if (!text || !buttons.length) return;

  const templates = {};
  document.querySelectorAll('template[id^="tab-"]').forEach(tpl => {
    templates[tpl.id] = tpl;
  });

  const setContent = id => {
    if (!templates[id]) return;
    text.innerHTML = templates[id].innerHTML;
  };

  // Estado inicial → primer bloque
  const first = buttons[0];
  if (first) {
    setContent(first.dataset.target);
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      buttons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      setContent(btn.dataset.target);
    });
  });
});
